import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import colors from "vuetify/lib/util/colors";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#F3F3F3", // #E53935
        secondary: "#82ACCA", // #FFCDD2
        accent: "#ADC5D6", // #3F51B5
      },
    },
  },
});
